import network from '@common/network/network';

export default {
  trackLogUsageAction(context, {event_name, obj_id}) {
    if (context.getters.userIsSharedState) {
      network.member.logUsage({event_name, obj_id});
    }
  },
};
